var _desc, _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCeurc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Celo Euro Currency Symbol")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#45CD85",
    cx: 500,
    cy: 500,
    r: 500
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M670 468l18-60H527v-15h166l18-60H546c18-27 49-42 88-42 28 0 56 8 83 25l20-65c-29-17-66-26-103-26-75 0-137 41-163 107h-44l-19 58h51v21h-32l-19 58h64c25 65 86 106 161 106 36 0 71-10 100-30v-79c-29 28-63 43-99 43-38 0-68-15-87-41h123zM445 714c-88 0-159-71-159-159 0-63 37-120 94-145v-81c-101 30-170 122-170 226 0 129 106 235 235 235 104 0 196-69 226-170h-81c-25 57-82 94-145 94z",
    fill: "#35C071"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M445 780c98 0 181-63 212-150h-61c-27 56-85 94-151 94-93 0-169-76-169-169 0-66 38-124 94-151v-61c-87 31-150 114-150 212 0 124 101 225 225 225zm188-215c33 0 64-9 90-25v-52c-25 19-55 31-89 31-48 0-86-23-104-61h133l12-40H518c-1-6-1-11-1-17s0-12 1-18h168l12-40H529c18-39 55-62 105-62 27 0 53 7 77 20l14-45c-27-14-59-21-91-21-75 0-134 43-156 107h-44l-12 38h48c-1 7-1 14-1 21s0 13 1 20h-36l-12 38h57c21 64 79 106 154 106z",
    fill: "#FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeurc);
export default __webpack_public_path__ + "static/media/ceurc.119d44bd.svg";
export { ForwardRef as ReactComponent };